import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HeaderMixin extends Vue {

  public transparentHeaderPages: string[] = [
    'about', 'to-renters', 'checkout', 'to-business', 'news', 'catalog',
  ];

  public spa: string[] = [
    'accounts', 'verify-lodger', 'message', 'verify-email',
  ];

  public get transparentHeader(): boolean {
    return this.filterPages(this.transparentHeaderPages);
  }

  public get spaPages(): boolean {
    return this.filterPages(this.spa);
  }

  public filterPages(array: string[]): boolean {
      return array.some((it) => it === this.$route.path.split('/')[1]);
  }
}
